import View from './views/View'

const route = {
    exact: true,
    purePath: '/user',
    path: '/:lang/user/:page?/:id?',
    component: View
}

export default route